module.exports = __webpack_public_path__ + "static/media/ricardo-fagundes.08df01cc.png";